import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=70e00858&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=70e00858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e00858",
  null
  
)

export default component.exports